<template>
    <div class="overflow-x-hidden">
        <section
            class="text-center grid flex flex-wrap justify-content-center align-items-center  py-4 md:px-4 md:px-6 relative">
             <div v-if="bckgroundUrl" class="background-image" :style="{ backgroundImage: `url('${bckgroundUrl}')`, zIndex: 0 }">
            </div>
            <img src="@/assets/Images/bird.png" alt="" class="decoration">
            <div class="col-10">
                <span class="badge mb-1">Institution</span>
                <h2 class=" mb-2 LandingPage-Title">
                    Take Your Institute to the Next Level
                </h2>
            </div>

            <div class="grid flex justify-content-center  align-items-stretch col-11 py-2 relative">
                <div class="institution-image relative border-round-3xl overflow-hidden mb-6 relative md:mx-4">
                    <img :src="bgUrl" alt="" class="">
                </div>
                <div v-for="(feature, index) in features" :key="index" class=" col-12 md:col-6 lg:col-4 md:px-4 py-4">
                    <div class="feature-card p-5 border-round-lg w-full flex flex-column "  v-animateonscroll="{ enterClass: 'animate-zoom-in'}">
                        <h3 class="Paragraph-Medium mb-3">{{ feature.title }}</h3>
                        <p class="mb-0 Caption flex-grow-1">{{ feature.description }}</p>
                    </div>
                </div>
            </div>

        </section>
    </div>
</template>
<script setup>
import { usePublicUrl } from "@/utils/getPublicUrl"

const bgUrl = usePublicUrl("public/nextLevel.jpg");
const bckgroundUrl = usePublicUrl("public/feature.png");
const features = [
    {
        title: "Expand Reach & Enrollment",
        description: "Connect with more students across Sri Lanka"
    },
    {
        title: "Streamline Operations",
        description: "Manage multiple teachers, schedules, and classes from a single dashboard"
    },
    {
        title: "Increase Credibility",
        description: "Institutes appear professional and tech-savvy"
    },
    {
        title: "Marketing & Visibility",
        description: "Get discovered by students actively searching for courses or tutors"
    },
    {
        title: "Revenue Growth",
        description: "More students → more classes → more income"
    },
    {
        title: "Enhance Student Engagement",
        description: "Use interactive tools and resources to keep students motivated and learning effectively"
    },
    {
        title: "Flexible Teaching Options",
        description: "Choose from different teaching options that would suit your needs"
    },
    {
        title: "Monitor Performance",
        description: "Use analytics to make data-driven decisions for growth"
    }
];
</script>
<style scoped>
.background-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.institution-image img {
    height: 310px !important;
    width: 100%;
    object-fit: cover;
}

/* Or target the container */
.institution-image {
    height: 310px !important;
    width: 100%;
}

.institution-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Responsive height */
@media (max-width: 768px) {

    .institution-image,
    .institution-image img {
        height: 250px !important;
    }
}

@media (max-width: 480px) {

    .institution-image,
    .institution-image img {
        height: 200px !important;
    }
}

/* Feature Cards */
.feature-card {
    background: #11CBFF;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    height: 100%; 
    
}

.feature-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.decoration {
    position: absolute;
    top: 0%;
    right: 0;
    z-index: 1;
    height: 250px;
    object-fit: contain;
}

/* Responsive styles */
@media (max-width: 768px) {
    .decoration {
        height: 150px;
    }
}

@media (max-width: 480px) {
    .decoration {
        height: 150px;
    }
}
</style>